<template>
    <div class="form-group lm-email-input" v-if="isVisible" :class="{ row : isOnModeLabelOnLeft }">
    <label
      :for="idComputed"
      :title="titleComputed"
      :class=" {'col-sm-2': isOnModeLabelOnLeft, 'col-form-label': isOnModeLabelOnLeft }"
      class="text-truncate"
      >{{label}} <small v-if="required">*</small></label>
    <font-awesome-icon
      id="font-awesome-icon-edit"
      icon="edit"
      size="sm"
      class="clickable float-right mt-1"
      :class="{ 'ml-2': help }"
      v-if="showEditButton"
      @click="$emit('edit-button-clicked')"
      />
    <font-awesome-icon
      icon="question-circle"
      size="sm"
      class="clickable float-right mt-1"
      v-if="help"
      v-b-tooltip.hover="help"
      />
    <div :class="{ 'col-sm-10': isOnModeLabelOnLeft }">
      <input
        :value="value"
        @input="$emit('input', $event.target.value)"
        @focusout="validateOnfocusOutMethod"
        class="form-control"
        :class="{'is-invalid': v.$error}"
        :readonly="readonly"
        :placeholder="placeholder"
        type="email"
        :id="idComputed"
        :disabled="disabled"
        />
      <p class="invalid-feedback" v-if="!v.required"> {{ $t('field_required')}} </p>
      <p class="invalid-feedback" v-if="!v.email"> {{ $t('valid_email')}} </p>
      </div>
    </div>
</template>

<script>
import lmInputMixin from '@/mixins/lmInputMixin.js'
export default {
  mixins: [lmInputMixin]
}
</script>
